module.exports = "<!--\n<span class=\"cssload-container\" *ngIf=\"loading\">\n    <div class=\"cssload-speeding-wheel\"></div>\n</span>\n-->\n<span class=\"cssload-container\" *ngIf=\"loading\">\n    <i class=\"fa fa-refresh fa-spin fa-1x fa-fw\"></i>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/spinner/spinner.component.html
// module id = ../../../../../src/app/spinner/spinner.component.html
// module chunks = main